import React, { FC } from 'react';
import Loader from './Loader';
import './Loadable.scss';

interface Props {
  loading: boolean;
  className?: string;
  children: any;
}

const Loadable: FC<Props> = ({ loading, className, children }) => {
  return (
    <div className={`loadable${loading ? ' loading' : ''} ${className || ''}`}>
      {children}
      {loading && (
        <div className="spinner">
          <Loader size="2x" />
        </div>
      )}
    </div>
  );
};

export default Loadable;
